import { useTranslation } from "react-i18next";

export default function Footer() {
	const { t, i18n } = useTranslation();

	const handleLanguageChange = (language: string) => {
		i18n.changeLanguage(language);
	};

	return (
		<footer className="h-16 text-xs md:text-sm flex w-full flex-col md:flex-row items-center justify-center md:justify-end gap-2 md:gap-10 text-muted-foreground px-12">
			<div className="flex gap-4 w-full md:w-auto items-center justify-center">
				<a href="https://american-way.de/legal/privacy">
					{t("footer.privacy_policy")}
				</a>
				<p className="text-muted-foreground">|</p>
				<a href="https://american-way.de/legal/terms">
					{t("footer.terms_of_service")}
				</a>
			</div>

			<div className="flex gap-4 w-full md:w-auto items-center justify-center">
				<button
					type="button"
					onClick={() => handleLanguageChange("de")}
					className={`hover:text-foreground transition-colors ${
						i18n.language === "de" ? "font-semibold text-foreground" : ""
					}`}
					aria-label={t("settings.language.toggle_german")}
				>
					Deutsch
				</button>
				<p className="text-muted-foreground">|</p>
				<button
					type="button"
					onClick={() => handleLanguageChange("en")}
					className={`hover:text-foreground transition-colors ${
						i18n.language === "en" ? "font-semibold text-foreground" : ""
					}`}
					aria-label={t("settings.language.toggle_english")}
				>
					English
				</button>
			</div>
		</footer>
	);
}
